import {useContext} from "react";
import './FileQueue.scss'
import AppContext from "../context/AppContext";
import {ProcessListEntryProcessing} from "../api/ProcessListClient";

export default () => {
    const { processList } = useContext(AppContext)

    if (!processList || (!processList.processing.length && !processList.queued)) {
        return (
            <div className="fq-empty">No active indexing jobs.</div>
        )
    }

    return (
        <div className="fq">
            <div className="fq-section">
                <div className="fq-section-title">
                    Processing ({processList.processing.length})
                </div>
                {processList.processing.length === 0 && (
                    <div className="fq-empty-section">Nothing processing right now.</div>
                )}
                {processList.processing.map(entry => (
                    <FqEntry key={entry.path} entry={entry}/>
                ))}
            </div>

            {processList.queued > 0 && (
                <div className="fq-section">
                    <div className="fq-section-title">
                        Queued ({processList.queued})
                    </div>
                    <div className="fq-queue-note">
                        {processList.queued} file{processList.queued !== 1 ? 's' : ''} waiting to be indexed.
                    </div>
                </div>
            )}
        </div>
    )
}

const FqEntry = ({ entry }: { entry: ProcessListEntryProcessing }) => {
    const status = entry.videoStatus || entry.photoStatus
    const name = entry.path.split('/').pop() || entry.path
    const pct = status?.percent ?? 0

    const badges = []
    if (status?.hasThumbnail) badges.push('thumb')
    if ((status as any)?.hasGif)    badges.push('gif')
    if ((status as any)?.hasSprite) badges.push('sprite')

    return (
        <div className="fq-entry">
            <div className="fq-entry-header">
                <span className="fq-type">{entry.fileType}</span>
                <span className="fq-name" title={entry.path}>{name}</span>
                {status && <span className="fq-pct">{pct}%</span>}
            </div>
            {status?.currentAction && (
                <div className="fq-action">{status.currentAction}</div>
            )}
            <div className="fq-track">
                <div className="fq-bar" style={{ width: `${pct}%` }}/>
            </div>
            {badges.length > 0 && (
                <div className="fq-badges">
                    {badges.map(b => <span key={b} className="fq-badge">{b} ✓</span>)}
                </div>
            )}
            {(status as any)?.error && (
                <div className="fq-error">{String((status as any).error)}</div>
            )}
        </div>
    )
}
